import {
  ECustomDataPackageType,
  setBillingUserType,
  setBuyPackageModalData,
  setCustomData,
} from '../../../../../shared/slices';
import { IBuyPackageHandlerParams } from '../../../../../shared/types/api';
import { IMicrofrontendMethodContext } from '../../../../../shared/types/microfrontend';
import { normalizePackageData } from './utils';

export const buyPackageHandler =
  ({ store }: IMicrofrontendMethodContext) =>
  async (params: IBuyPackageHandlerParams): Promise<void> => {
    const { billingUserType, paymentInitSource } = params;

    const packageData = normalizePackageData(params.packageData);

    store.dispatch(setBillingUserType(billingUserType));
    store.dispatch(setCustomData({ paymentInitSource, packageType: ECustomDataPackageType.Package }));
    store.dispatch(setBuyPackageModalData(packageData));
  };
